import { Component, OnInit, Inject } from '@angular/core';
import { IDocumentApprovalModel, IDocumentUploadStatusModel } from 'src/app/ViewModel/DocumentModel';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FileUploadComponent } from 'src/app/CommonComponents/file-upload/file-upload.component';
import { FileUploadLibrary } from 'src/app/Service/file/file.service';
import { CommonService } from 'src/app/Service/Common.service';
import { DocumentService } from 'src/app/Service/document/document.service';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { NotificationService } from 'src/app/Service/notification.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { formatDate } from '@angular/common';
@Component({
  selector: 'app-excelupload',
  templateUrl: './excelupload.component.html',
  styleUrls: ['./excelupload.component.css']
})
export class ExceluploadComponent implements OnInit {
  enableFullscreen = false;
  enableFilter = false;
  statusList: IDocumentUploadStatusModel[] = [];
  public projectId!: number;
  public groupId!: number;
  public memberId!: number;
  public isShowBulkUpload: boolean = true;
  UnsubscribeArray: Subscription[] = [];

  constructor(public commonService: CommonService, private _docService: DocumentService,
    private _notificationService: NotificationService, public dialogRef: MatDialogRef<ExceluploadComponent>, private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public _data: IDocumentUploadStatusModel[]) {
    this.statusList = _data;
  }
  ngOnInit() {
    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.memberId = this.commonService.getLoggedInUserId();

    this.isShowBulkUpload = this.statusList.filter(item => item.status == true).length != 0 ? true : false;
  }

  closeDialog() {
    this.dialogRef.close();
  }
  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  toggleFullscreen() {
    this.enableFullscreen = !this.enableFullscreen;
  }

  getStatus(item: IDocumentUploadStatusModel): string {
    return item.status ? "Success" : "Fail";
  }

  public showOnlyFailureDetails(dataItem: IDocumentUploadStatusModel, index: number): boolean {
    return dataItem.status == false;
  }



  bulkAttachmentClick(gridData: IDocumentUploadStatusModel[]) {
    if (gridData.filter(item => item.status == true).length > 0) {
      let documentList: Array<any> = new Array<any>();
      let _data = gridData.filter(item => item.status == true);
      _data.forEach((dataItem, rowIndex) => {
        if (documentList.filter(x => x.value == dataItem.docId).length == 0)
          documentList.push({ value: dataItem.docId, text: dataItem.docNo, revisionNo: dataItem.revisionNo, task_SNo: 0, authorisedBy: dataItem.authorisedBy, revisedOn: dataItem.revisedOn });
      });

      this.attachmentClick(documentList)
    }
  }

  attachmentClick(data: any) {
    const dialog = this.dialog.open(FileUploadComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '45%',
      data: { projectId: this.projectId, docId: data[0].value, revisionNo: data[0].revisionNo, libraryName: FileUploadLibrary.Documents, createdBy: this.memberId, documents: data, isEditable: true, docNo: data[0].text },
    });
    dialog.afterClosed().subscribe((res: any) => {
      data.forEach((dataItem) => {
        // if (dataItem.authorisedBy == this.memberId) {
        let inputModel: IDocumentApprovalModel = {
          DocId: dataItem.value,
          RevisionNo: dataItem.revisionNo,
          RevisedOn: formatDate(dataItem.revisedOn, 'dd-MMM-yyyy', 'en-US'),
          IsApproved: true,
          ApprovedBy: this.memberId
        };
        let docApprovalattachment = this._docService.DocumentApproval(inputModel).subscribe((res: StandardOutputModel) => {
          if (res.successCode == 200) {
            this._notificationService.showToast(res.successMessage, "Success");
          }
          else if (res.successCode == 500) {
            this._notificationService.showToast(res.successMessage, "Error");
          }
        });
        this.UnsubscribeArray.push(docApprovalattachment);
        //}
      });
      this.closeDialog();
    });
  }
}
